// src/redux/slices/menteesRequestSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";
import { showErrorToaster } from "../../../utils/helpers";

// LOAD CURRENT MENTEES (status = 4 always)
export const loadPendingRequestData = createAsyncThunk(
    "mentees/loadPendingRequestData",
    async ({ request, status }, { rejectWithValue }) => {
        try {
            const params = { ...request, type: "current" };

            const res = await agent.get(`${API.LOAD_MENTEE_REQUEST}/${status}`, {
                params,
            });

            const data = res?.data?.data?.data || [];
            const pagination = res?.data?.data?.pagination || {};

            return {
                data,
                pagination,
                notFound: data.length > 0,
            };
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const mentorDashboard1Slice = createSlice({
    name: "mentorDashboard1",
    initialState: {
        mentorDashboard1Data: [],
        pagination: {},
        loading: false,
    },
    reducers: {
        toggleNetworkRequestStatus: (state, action) => {
            state.networkBusy = action.payload;
        },
        loadNotFoundDataSuccess: (state, action) => {
            state.notFound = action.payload;
        },
        loadDataSuccess: (state, action) => {
            state.mentorDashboard1Data = action.payload;
        },
        loadPaginationDataSuccess: (state, action) => {
            state.pagination = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(loadPendingRequestData.pending, (state, action) => {
                const { request } = action.meta.arg;

                if (request.short || request.keyword || request.page) {
                    state.networkBusy = true;
                }

                state.loading = true;
            })

            .addCase(loadPendingRequestData.fulfilled, (state, action) => {
                state.loading = false;
                state.networkBusy = false;

                const { data, pagination, notFound } = action.payload;

                state.mentorDashboard1Data = data;
                state.pagination = pagination;
                state.notFound = notFound;
            })

            .addCase(loadPendingRequestData.rejected, (state, action) => {
                state.loading = false;
                state.networkBusy = false;
                state.notFound = false;
                showErrorToaster(action.payload || "Something went wrong");
            });
    },
});

export const {
    toggleNetworkRequestStatus,
    loadNotFoundDataSuccess,
    loadDataSuccess,
    loadPaginationDataSuccess,
} = mentorDashboard1Slice.actions;

export default mentorDashboard1Slice.reducer;
